export const homeObjOne = {
  lightBg: false,
  imgStart: "start",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description: "",
  headline: "We Promote Authentic Serbian Brands and Products",
  lightText: true,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/Simg14.jpg"),
  alt: "Image",
  start: "true",
};

export const homeObjTwo = {
  lightBg: true,
  imgStart: "",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "Melodija Distillery from Niš, produces authentic fruit rakias using the latest distillation equipment. Notably, their plum rakia, aged over 12 months, and the golden quince rakia, aged in oak barrels for more than 2 years, stand out.",
  headline: "Rakija - Fruit Brandy",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg08.jpg"),
  alt: "Image",
  start: "",
};

export const homeObjThree = {
  lightBg: true,
  imgStart: "start",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "Processes goat milk on their own farm, adhering to the highest European and global standards.",
  headline: "Select Milk",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg11.jpg"),
  alt: "Image",
  start: "start",
};

export const homeObjFour = {
  lightBg: true,
  imgStart: "",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "This cheese undergoes a unique two-phase aging process, giving it characteristics similar to traditional cheeses.",
  headline: "Maestro Semi-Hard Cheese",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg03.jpg"),
  alt: "Image",
  start: "",
};

export const homeObjFive = {
  lightBg: true,
  imgStart: "start",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "Produced with technology developed in our dairy, the aging process imparts a unique aroma and taste. Enjoy it with good wine for a long and healthy life.",
  headline: "Select Milk Semi-Hard Goat Cheese",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg04.jpg"),
  alt: "Image",
  start: "start",
};

export const homeObjSix = {
  lightBg: true,
  imgStart: "",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "Known for its exceptional spreadability and rich flavour, this cheese is also a great source of essential proteins, vitamins, and minerals necessary for daily nutrition. It is perfect for preparing various salads, sandwiches, pies, and cakes.",
  headline: "Select Milk Fresh Goat Cheese",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg05.jpg"),
  alt: "Image",
  start: "",
};

export const homeObjSeven = {
  lightBg: true,
  imgStart: "start",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    'Cured meats family busines from Sremska Mitrovica. Their "kulen" has won multiple domestic and international awards. Their selection also includes Sremska sausages and pork cracklings, which are authentic Serbian products.',
  headline: "Kosanović Meat Processing",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg06.jpg"),
  alt: "Image",
  start: "start",
};

export const homeObjEight = {
  lightBg: true,
  imgStart: "",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "This brand emerged from family efforts on an old estate in the small village of Slavkovica, located on the slopes of Rajac Mountain. Since 2017, we have been revitalizing this estate, growing raspberries, and producing all our products directly from fresh fruits on our plantation. Our goal is to create high-quality, healthy, and tasty products, with significant help from the local community, which we are very proud of. We strive to maintain high fruit content in all our products, ensuring quality and establishing ourselves as a recognizable brand in healthy food production. Customer satisfaction and a special award at the Ethno Fair last year show our success.",
  headline: "Plodovi Mog Imanja - Fruits of My Estate",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg07.jpg"),
  alt: "Image",
  start: "",
};
